<template>
<div>
    <div class="box-page" v-if="isShowList" key="tran1">
        <div class="page-header">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">ต่ออายุสมาชิก</span>
                <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-search2">
                        <i class="fa fa-search"></i>
                        <input type="text" name="search" placeholder="ค้นหาชื่อและเบอร์โทร" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content">
            <div class="row pb-2">
                <div class="col-md-6 box-info-bar px-2">
                    <div class="info-bar accent-purple">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ยอดเงินรวมทั้งหมด</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value">{{ total_current_money }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-4 box-info-bar px-2">
                    <div class="info-bar accent-purple">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">สมาชิกทั้งหมด</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value">{{ total_member }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 box-info-bar px-2">
                    <div class="info-bar accent-red">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">สมาชิกหมดอายุ</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value">{{ total_expired_member }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 box-info-bar px-2">
                    <div class="info-bar accent-green">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">สมาชิกต่ออายุแล้ว</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value">{{ total_active_member }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100" style="overflow-x: auto;">
                <table id="tb_datalist" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width: 170px; min-width: 170px;">
                            </th>
                            <th style="width: 70px; min-width: 70px;">
                                <div class="text-btn header-text text-center" @click="toggleSort('id');">
                                    <span>ลำดับ</span>
                                    <i class="fa" :class="getClassChevron('id')"></i>
                                </div>
                            </th>

                            <th style="width: 100px; min-width: 100px;">
                                <div class="header-text text-center">
                                    <span>สถานะการต่ออายุ</span>
                                </div>
                            </th>

                            <th style="width: 100px; min-width: 100px;">
                                <div class="header-text text-center">
                                    <span>วันที่สมัคร</span>
                                </div>
                            </th>

                            <th style="width: 140px; min-width: 140px;">
                                <div class="header-text text-center">
                                    <span>วันต่ออายุ</span>
                                </div>
                            </th>

                            <th style="width: 140px; min-width: 140px;">
                                <div class="header-text text-center">
                                    <span>วันต่อหมดอายุ</span>
                                </div>
                            </th>

                            <th style="width: 140px; min-width: 140px;">
                                <div class="header-text text-center">
                                    <span>เข้าใช้งานล่าสุด</span>
                                </div>
                            </th>

                            <th>
                                <div class="header-text">
                                    <span>ชื่อ</span>
                                </div>
                            </th>
                            <th style="width: 180px;">
                                <div class="header-text text-left">
                                    <span>เบอร์โทร</span>
                                </div>
                            </th>

                            <th>
                                <div class="text-btn header-text" @click="toggleSort('current_money');">
                                    <span>ยอดเงิน</span>
                                    <i class="fa" :class="getClassChevron('current_money')"></i>
                                </div>
                            </th>

                            <th style="width: 100px; min-width: 100px;">
                                <div class="header-text text-center">
                                    <span>วันที่จ่ายเงิน</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listMember" :key="idx">
                            <td class="align-middle">
                                <div class="show-on-hover">
                                    <div class="btn-group">
                                        <a href="#" class="btn btn-table" @click="showRenewDetail(item.id)">ต่ออายุ</a>
                                    </div>
                                    <div class="btn-group">
                                        <a data-toggle="dropdown" href="">
                                            <img height="24" :src="'../../goobank_assets/common/img/icons/threedots.png'" />
                                        </a>
                                        <div class="dropdown-menu">
                                            <a href="#" class="dropdown-item" @click="showEditPaymentSlip(item)">สลิปจ่ายเงิน</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-text="getRowNo(idx + 1)"></span>
                            </td>

                            <td>
                                <span class="tag-staff" :class="getCssStatus(item.renew_status)" v-text="getRenewStatusText(item.renew_status)"></span>
                            </td>

                            <td class="text-center">
                                <span v-text="item.created_at_text"></span>
                            </td>

                            <td class="text-center">
                                <span v-text="item.renew_at_text"></span>
                            </td>

                            <td class="text-center">
                                <span v-text="item.renew_date_text"></span>
                            </td>

                            <td class="text-center">
                                <span v-text="item.last_login_text"></span>
                            </td>

                            <td>
                                <span v-text="item.member_name"></span>
                            </td>
                            <td>
                                <span v-text="item.telephone"></span>
                            </td>

                            <td>
                                <span v-text="item.current_money"></span>
                            </td>

                            <td>
                                <span v-text="item.payment_date_text"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="listMember.length <= 2" style="display:block;height:200px"></div>
                <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
            </div>
        </div>
    </div>

    <member-renew-detail v-if="isShowRenewDetail" ref="memberRenewDetail" :base-url="baseUrl"
    :storagePath="storagePath"
    @hideRenewDetail="hideRenewDetail" :read-only="true" key="tran2"></member-renew-detail>

    <member-payment-slip v-if="isShowPaymentSlip" ref="memberPaymentSlip" :base-url="baseUrl"
    :storagePath="storagePath"
    @hideEditPaymentSlip="hideEditPaymentSlip" :read-only="true" key="tran3"></member-payment-slip>

    <div class="modal-group" key="tran4">
        
    </div>
</div>
</template>

<script>
    import VeeValidate, { Validator } from 'vee-validate';
    import MemberRenewDetail from './partial/MemberRenewDetailComponent.vue';
    import MemberPaymentSlip from './partial/MemberPaymentSlipComponent.vue';
    import PaginationComponent from './../sub_components/PaginationComponent';
    import Loading from 'vue-loading-overlay';
    Vue.use(VeeValidate);
    Vue.use(Loading);
    export default {
        components: {
            'member-renew-detail': MemberRenewDetail,
            'member-payment-slip': MemberPaymentSlip,
            PaginationComponent,
            Loading,
        },
        data: function () {
            return {
                listMember: [],
                startDate: null,
                endDate: null,
                keyword: '',
                showComponent: '',
                memberID: null,
                phoneUpdate: null,
                totalItems: 0,
                totalPage: 1,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                loader: null,
                total_current_money: 0,

                total_member: 0,
                total_expired_member: 0,
                total_active_member: 0,

                sortValue: ['id', 'DESC'],
            }
        },
        mounted() {
        },
        created() {
            this.buildJquery();
            this.customValidate();
            this.loadList();
            setInterval(() => {
                this.loadList();
            }, 5000);
        },
        computed: {
            isShowList() {
                return this.showComponent === '';
            },
            isShowRenewDetail() {
                return this.showComponent === 'renew-detail';
            },
            isShowPaymentSlip() {
                return this.showComponent === 'payment-slip';
            },
        },
        methods: {
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            loginAsUser(userId) {
                // console.log(`${this.baseUrl}/admin/api/login-as/${userId}`)
                window.location.href = `${this.baseUrl}/admin/api/login-as/${userId}`
            },
            customValidate() {
                let timeValidate = null;
                Validator.extend('phone_exists', {
                    getMessage: field => 'phone exists.',
                    validate: async value => {
                        clearTimeout(timeValidate);
                        await new Promise(resolve => {
                            timeValidate = setTimeout(() => {
                                resolve();
                            }, 500);
                        });
                        let isExists = false;
                        if (timeValidate) {
                            isExists = await axios.post(`${this.baseUrl}/api/register/check-existing-phone`,
                                { telephone: this.phoneUpdate, id: this.memberID }
                            ).then(({ data }) => {
                                if (data && data.success === false) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                        }
                        return !isExists;
                    }
                });
            },
            showLoading() {
                this.loader = this.$loading.show({
                    canCancel: false,
                });
            },
            hideLoading() {
                if (this.loader != null) {
                    this.loader.hide();
                }
            },
            loadList() {
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage,
                    sort: JSON.stringify(this.sortValue)
                };

                axios.post(`${this.baseUrl}/admin/api/list-renew-member`, params).then(({ data }) => {
                    if (data != null) {
                        const rows = Array.isArray(data.data) ? data.data : [];
                        if (rows.length > 0) {
                            rows.forEach(item => {
                                item.created_at_text = moment(item.created_at).format('DD/MM/YYYY');
                                if (item.last_login) {
                                    item.last_login_text = moment(item.last_login).format('DD/MM/YYYY HH:mm');
                                }

                                if (item.renew_date) {
                                    item.renew_date_text = moment(item.renew_date).format('DD/MM/YYYY');
                                } else {
                                    item.renew_date_text = 'สมาชิกตลอดชีพ';
                                }

                                if (item.payment_date) {
                                    item.payment_date_text = moment(item.payment_date).format('DD/MM/YYYY');
                                } else {
                                    item.payment_date_text = '-';
                                }

                                if (item.renew_at) {
                                    item.renew_at_text = moment(item.renew_at).format('DD/MM/YYYY HH:mm');
                                } else {
                                    item.renew_at_text = '-';
                                }
                            });
                        }
                        this.totalItems = (parseInt(data.total, 10) || 0);
                        this.lastPage = (parseInt(data.totalPage, 10) || 1);
                        this.listMember = rows;
                        this.total_current_money = data.total_current_money;

                        this.total_member = data.total_member;
                        this.total_expired_member = data.total_expired_member;
                        this.total_active_member = data.total_active_member;

                        this.$nextTick(() => {
                            if (this.$refs.pagination && typeof this.$refs.pagination.bindListPageNo === 'function') {
                                this.$refs.pagination.bindListPageNo();
                            }
                        });
                    }
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            verifyRegister(id) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'อนุมัติการสมัครใช่หรือไม่ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/verify-register`, { id }).then(({ data }) => {
                            if (data != null && data.success) {
                                alertbox('บันทึกสำเร็จ');
                                this.loadList();
                            }
                        });
                    }
                });
            },
            buildJquery() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        startDate: new Date(),
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                                vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                            }
                            vm.loadList();
                        }
                    });
                });
            },
            showRenewDetail(memberID) {
                this.showComponent = 'renew-detail';
                const vm = this;
                this.showLoading();
                this.$nextTick(() => {
                    vm.$refs.memberRenewDetail.showMemberRenewDetail(memberID)
                    .catch(err => console.log('showMemberRenewDetail', err))
                    .then(() => this.hideLoading());
                });
            },
            hideRenewDetail(isReloadList) {
                this.showComponent = '';
                if (isReloadList) {
                    this.loadList();
                }
            },
            showEditPaymentSlip(itemMember) {
                this.showComponent = 'payment-slip';
                const vm = this;
                this.$nextTick(() => {
                    vm.$refs.memberPaymentSlip.showPaymentSlipDetail(itemMember);
                });
            },
            hideEditPaymentSlip(isReloadList) {
                this.showComponent = '';
                if (isReloadList) {
                    this.loadList();
                }
            },
            openModalRenewUpdate(memberID, phone) {
                this.memberID = memberID;
                this.phoneUpdate = phone;
                this.errors.clear();
                $('#modal_change_phone').modal('show');
            },
            changMemberPhoneNo() {
                this.$validator.validate('phoneUpdate')
                .then(isValid => {
                    if (!isValid) {
                        return;
                    }
                    $.confirmbox({
                        title: 'ยืนยัน',
                        msg: 'ยืนยันการแก้ไขเบอร์โทร ?',
                        confirmEvent: () => {
                            axios.post(`${this.baseUrl}/admin/api/change-member-phone`, {
                                id: this.memberID, phone: this.phoneUpdate
                            }).then(({ data }) => {
                                if (data != null && data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                }
                            });
                            $('#modal_change_phone').modal('hide');
                        }
                    });
                });
            },
            deleteMember(memberID) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'ยืนยันการลบ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/delete-member`, {
                            id: memberID
                        }).then(({ data }) => {
                            if (data != null) {
                                if (data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                } else if (data.message) {
                                    alertbox(data.message);
                                }
                            }
                        });
                    }
                });
            },
            permanentDeleteMember(memberID) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'ยืนยันการลบสมาชิกออกจากฐานข้อมูล ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/permanent-delete-member`, {
                            id: memberID
                        }).then(({ data }) => {
                            if (data != null) {
                                if (data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                } else if (data.message) {
                                    alertbox(data.message);
                                }
                            }
                        });
                    }
                });
            },
            changePassword(memberID) {
                $.confirmbox({
                    title: 'ยืนยันเปลี่ยนรหัส',
                    msg: 'รหัสจะส่ง SMS ไปที่เบอร์โทรศัพท์ของผู้ใช้ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/change-password-member`, {
                            id: memberID
                        }).then(({ data }) => {
                            if (data != null) {
                                if (data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                } else if (data.message) {
                                    alertbox(data.message);
                                }
                            }
                        });
                    }
                });
            },
            toggleStatus(memberID, status) {
                axios.post(`${this.baseUrl}/admin/api/toggle-member-status`, {
                    id: memberID, status: !status
                }).then(({ data }) => {
                    if (data != null) {
                        if (data.success) {
                            alertbox('บันทึกสำเร็จ');
                            this.loadList();
                        } else if (data.message) {
                            alertbox(data.message);
                        }
                    }
                });
            },
            getRenewStatusText(status) {
                if(status === 'active') {
                    return 'ต่ออายุแล้ว';
                } else if(status === 'near-expired') {
                    return 'ใกล้หมดอายุ';
                } else if(status === 'expired') {
                    return 'หมดอายุ'
                }
            },
            getCssStatus(status) {
                if(status === 'active') {
                    return 'tag-green';
                } else if(status === 'near-expired') {
                    return 'tag-orange';
                } else if(status === 'expired') {
                    return 'tag-red'
                }
            },
            toggleSort(sort) {
                let asc = this.sortValue[1];
                if (sort == this.sortValue[0]) {
                    if (asc.toLowerCase() == 'desc') {
                        asc = 'asc'
                    } else {
                        asc = 'desc'
                    }
                } else {
                    asc = 'desc'
                }
                this.sortValue = [sort, asc];
                this.loadList();
            },
            getClassChevron(columnName) {
                let result = 'fa-chevron-down';
                if (columnName == this.sortValue[0]) {
                    if (this.sortValue[1].toLowerCase() == 'desc') {
                        result = 'fa-chevron-up';
                    }
                    result += ' active';
                }
                return result;
            },
            gotoDetailPage(id) {
                location.href = this.baseUrl + '/admin/member/detail/' + id;
            },
        },
        props: {
            baseUrl: '',
            storagePath: '',
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    #v_app {
        height: 100%;
    }
    .ele-search {
        margin-left: auto;
        margin-right: 0;
        width: 400px;
        max-width: 400px;
    }
    .img-avatar {
        width: 24px;
        height: 24px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .tag-active {
        width: 90px;
        display: inline-block;
        min-width: initial;
    }
    .error-text {
        font-size: 14px;
        color: $main-color-red
    }
</style>




